import { AlterSituacaoEnum, SituacaoRestricEnumRegistro, PerfilRestrictEnumRegistro } from "../enums/Enumarations";
import { BaseImplemantation } from './base-system-implementation';
/**
 * Implementação da Interface sistema para o sistema Registro para restrição de acesso ao usuário.
 */
export class RegistroImplementation extends BaseImplemantation {
    situacaoAlter = AlterSituacaoEnum;
    perfilRestrict = PerfilRestrictEnumRegistro;
    situacaoRestric = SituacaoRestricEnumRegistro;
    componentsAppMenu = [
        {
            label: 'Cadastro', icon: 'recent_actors', routerLink: ['cadastro'], items: [
                { label: 'Pessoa Física', icon: 'recent_actors', routerLink: ['cadastro/pessoa-fisica'] },
                { label: 'Pessoa Jurídica', icon: 'recent_actors', routerLink: ['cadastro/pessoa-juridica'] }
            ]
        },
        {
            label: 'Parametrização', icon: 'dashboard', routerLink: ['parametrizacao'], items: [
                { label: 'Órgão Expedidor', icon: 'group_add', routerLink: ['parametrizacao/orgao-expedidor'] }
            ]
        },
        {
            label: 'Instituição Ensino', icon: 'account_balance', routerLink: ['instituicao-ensino'], items: [
                { label: 'Tipo de Título', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/tipo-titulo'] },
                { label: 'Natureza Título', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/natureza-titulo'] },
                { label: 'Área Fomação', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/area-formacao'] },
                { label: 'Instituição', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/instituicao'] }
            ]
        }
    ];
    
    dataTableFunction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) {
        switch (event.button) {
            default:
                this.showMsg('warn', 'Mensagem de Alerta', 'Opção não existe.');
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/base/use-system/implementation-system/registro-system-implementation.ts